import { render, staticRenderFns } from "./AmountInfo.vue?vue&type=template&id=46670f49&scoped=true&"
import script from "./AmountInfo.vue?vue&type=script&lang=js&"
export * from "./AmountInfo.vue?vue&type=script&lang=js&"
import style0 from "./AmountInfo.vue?vue&type=style&index=0&id=46670f49&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46670f49",
  null
  
)

export default component.exports